import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 3,
    class: "deleted-item"
};
const _hoisted_2 = { class: "ta-c" };
const _hoisted_3 = { class: "ta-c" };
import { routeName } from '@/constants/routeName';
import dateFormatType from '@/constants/dateFormatType';
import { isTodayTextColor, formatDate, } from '@/utils';
import { autoLcStoreWorkProcess } from '@/locales/ko/views/store_work_process';
import { computed } from 'vue';
import { pStore } from '@/pinia';
import { prevData } from '@/pinia/storeWorkProcess';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Item',
    props: {
        item: {}
    },
    setup(__props) {
        const props = __props;
        const lc = autoLcStoreWorkProcess();
        /** 글 제목 */
        const title = computed(() => {
            if (props.item.isDeleted) {
                return lc('deleted_item');
            }
            return props.item.title;
        });
        /** 작성자 */
        const writer = computed(() => `${props.item.createdByName} (${props.item.createdBy})`);
        /** 좌측 여백 */
        const leftPadding = computed(() => {
            const depth = props.item.displayDepth;
            let value = 0;
            switch (depth) {
                case 0:
                    value = 0;
                    break;
                case 1:
                    value = depth * 10;
                    break;
                default:
                    value = depth * 20;
                    break;
            }
            return {
                paddingLeft: `${value}px !important`,
            };
        });
        /**
         * 링크 경로
         */
        const to = () => ({
            name: routeName.STORE_WORK_PROCESS_DETAIL,
            params: {
                itemId: props.item.id,
            },
        });
        /**
         * 링크 클릭 핸들러
         */
        const handleClickLink = () => {
            // 현재 페이지네이션 번호 저장
            prevData.pageNumber = pStore.piniaStoreWorkProcess.filterOption.pageNumber;
        };
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("tr", null, [
                _createElementVNode("td", null, _toDisplayString(props.item.id), 1 /* TEXT */),
                _createElementVNode("td", {
                    style: _normalizeStyle(leftPadding.value)
                }, [
                    (props.item.isReply)
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 0,
                            class: "ml-1 mr-1 brg-color-grey-600"
                        }, {
                            default: _withCtx(() => _cache[0] || (_cache[0] = [
                                _createTextVNode(" mdi-arrow-right-bottom ")
                            ])),
                            _: 1 /* STABLE */,
                            __: [0]
                        }))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" 중요 여부 표기 "),
                    (props.item.isImportant)
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 1,
                            class: "mr-1 brg-color-red-700",
                            title: "중요"
                        }, {
                            default: _withCtx(() => _cache[1] || (_cache[1] = [
                                _createTextVNode(" mdi-alert-circle-outline ")
                            ])),
                            _: 1 /* STABLE */,
                            __: [1]
                        }))
                        : _createCommentVNode("v-if", true),
                    (!props.item.isDeleted)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 2,
                            class: "cy-link",
                            to: to(),
                            onClick: handleClickLink
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(title.value), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["to"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_unref(lc)('deleted_item')), 1 /* TEXT */))
                ], 4 /* STYLE */),
                _createElementVNode("td", _hoisted_2, _toDisplayString(writer.value), 1 /* TEXT */),
                _createElementVNode("td", _hoisted_3, [
                    _createElementVNode("span", {
                        class: _normalizeClass(_unref(isTodayTextColor)(props.item.createdAt))
                    }, _toDisplayString(_unref(formatDate)(props.item.createdAt, _unref(dateFormatType).FULL_DATE)), 3 /* TEXT, CLASS */)
                ])
            ]));
        };
    }
});
